import React, { Component } from 'react'
import '../styles/MobileMenu.css'
import TicketIcon from '../images/icons/ticket.png'
import { injectIntl, defineMessages } from "react-intl"
import { Link, withRouter } from 'react-router-dom'
import { webURL } from '../webURL'

class MobileMenu extends Component {

  constructor(props) {
    super(props)
    this.state = {
      mobileMenu: false,
      themesMenu: false
    }
  }

  toggleThemes = () => {
    const dropDown = document.getElementById("mobile-menu-link-dropdown")
    if (!this.state.themesMenu) {
      this.setState({ themesMenu: true })
      dropDown.style.display = "inline-block"
      dropDown.style.maxHeight = dropDown.scrollHeight + "px"
    } else {
      this.setState({ themesMenu: false})
      dropDown.style.maxHeight = 0
      window.setTimeout(x => {
        dropDown.style.display = "none"
      }, 300)
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    return(
        <div className="mobile-menu-overlay" id="mobile-menu-overlay">
          <div className="mobile-menu">
            <div className="mobile-menu-links-container">
              <div className="mobile-menu-link" onClick={() => this.toggleThemes()}>
                {formatMessage(messages.themes)}
                <span className={`navigation-item-arrow navigation-item-arrow--mobile ${this.state.themesMenu ? "navigation-item-arrow--up" : null}`}></span>
              </div>
              <div className="mobile-menu-link-dropdown" id="mobile-menu-link-dropdown">
                <div className="navigation-scrolldown-item navigation-scrolldown-item--category">One Hour Charonne</div>
                <Link to="/lost-asylum/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.la)}</span></div></Link>
                <Link to="/very-bad-night/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.VBN)}</span></div></Link>
                <div className="navigation-scrolldown-item navigation-scrolldown-item--category">One Hour Voltaire</div>
                <Link to="/abattoir/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.slaughterhouse)}</span></div></Link>
                <Link to="/yakuza/"><div className="navigation-scrolldown-item"><span>{formatMessage(messages.yakuza)}</span></div></Link>
				<Link to="/expedition-maudite/"><div className="navigation-scrolldown-item navigation-scrolldown-item--hidden"><span>{formatMessage(messages.expedition)}</span></div></Link>
              </div>
              <Link to="/team-building/">
                {formatMessage(messages.teambuilding)}
              </Link>
              <Link to="/carte-cadeaux/">
                {formatMessage(messages.giftCard)}
              </Link>
              <Link to="/reserver/">
                {formatMessage(messages.book)}
              </Link>
            </div>
            <div className="mobile-menu-footer">
              <div className="mobile-menu-footer-column">
                <Link to="/faq/">{formatMessage(messages.faq)}</Link>
                <a rel="noopener noreferrer" href={`${webURL}contact/`}>{formatMessage(messages.contact)}</a>
              </div>
              <div className="mobile-menu-footer-column">
                <a rel="noopener noreferrer" href="https://escape-game-paris.one-hour.fr/">{formatMessage(messages.blog)}</a>
                <a rel="noopener noreferrer" href={`${webURL}presse/`}>{formatMessage(messages.press)}</a>
              </div>
            </div>
            <Link to="/reserver/">
              <div className="cta-booking cta-booking--mobile">
                <div className="ticket-container">
                  <img className="ticket" src={TicketIcon} alt="ticket-icon"/>
                  <div className="cta-booking-text">{formatMessage(messages.book)}</div>
                </div>
              </div>
            </Link>
            <div className="social-icons--mobile">
              <a target="_blank" rel="noopener noreferrer"
                href="https://www.facebook.com/onehourliveescapegame/"
                className="icon-container">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer"
                href="https://twitter.com/onehour_escape"
                className="icon-container">
                <i className="fab fa-twitter"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer"
                href="https://www.tripadvisor.fr/Attraction_Review-g187147-d8843110-Reviews-One_Hour_Live_Escape_Game-Paris_Ile_de_France.html"
                className="icon-container">
                <i className="fab fa-tripadvisor"></i>
              </a>
              <a target="_blank" rel="noopener noreferrer"
                href=""
                className="icon-container">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
    )
  }
}

const messages = defineMessages({
  blog: {
    id: 'footer.blog',
    defaultMessage: 'Blog'
  },
  contact: {
    id: 'footer.contact',
    defaultMessage: 'Contact'
  },
    press: {
    id: 'footer.press',
    defaultMessage: 'Presse'
  },
    faq: {
    id: 'footer.faq',
    defaultMessage: 'FAQ'
  },
  themes: {
    id: 'navbar.themes',
    defaultMessage: 'Les thèmes'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  la: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  expedition: {
    id: 'themes.expedition',
    defaultMessage: "Expédition Maudite"
  },
  book: {
    id: 'navbar.cta',
    defaultMessage: 'Réserver'
  },
  teambuilding: {
    id: 'navbar.teambuilding',
    defaultMessage: 'TeamBuilding'
  },
  giftCard: {
    id: 'navbar.giftcard',
    defaultMessage: 'Carte Cadeaux'
  },
})

export default withRouter(injectIntl(MobileMenu))



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js